import React from 'react';
import Footer from '../components/Footer';
import { 
  PageContainer, 
  Content, 
  Title, 
  Section, 
  SectionTitle, 
  Paragraph, 
  List, 
  ListItem, 
  LastUpdated 
} from '../components/LegalPageLayout';

const TermsPage = () => {
  // ScrollToTop is now handled globally in App.js

  return (
    <PageContainer>
      <Content>
        <Title>Terms and Conditions</Title>
        <LastUpdated>Last updated: January 1, 2025</LastUpdated>
        
        <Section>
          <Paragraph>
            Welcome to The Sol Room. These Terms and Conditions govern your use of our fitness studio services, 
            website, and facilities. By booking classes, using our services, or visiting our studio, you agree 
            to be bound by these terms.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Studio Policies</SectionTitle>
          <Paragraph>
            <strong>Class Reservations:</strong> All classes must be reserved in advance through our booking system. 
            Class capacity is limited and spots are secured on a first-come, first-served basis.
          </Paragraph>
          <Paragraph>
            <strong>Cancellation Policy:</strong> Classes may be cancelled up to 12 hours before the scheduled start time 
            without penalty. Late cancellations or no-shows may result in loss of class credit or additional fees.
          </Paragraph>
          <Paragraph>
            <strong>Arrival Time:</strong> Please try to arrive before your scheduled class. Arrivals 10 minutes after the start of the class may
            not be admitted to maintain the experience for other participants.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Health and Safety</SectionTitle>
          <Paragraph>
            <strong>Waiver Requirement:</strong> All clients are required to sign a liability waiver before their first 
            class. This waiver must be completed and submitted prior to participating in any studio activities.
          </Paragraph>
          <Paragraph>
            <strong>Health Clearance:</strong> You confirm that you are in good physical condition and have no medical 
            conditions that would prevent safe participation in physical exercise.
          </Paragraph>
          <Paragraph>
            <strong>Injury Disclosure:</strong> Please inform instructors of any injuries, physical limitations, or 
            medical conditions before class begins. Modifications will be provided as needed.
          </Paragraph>
          <Paragraph>
            <strong>Personal Responsibility:</strong> You participate in all classes and use studio equipment at your 
            own risk. Listen to your body and work within your personal limits.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Liability and Assumption of Risk</SectionTitle>
          <Paragraph>
            Physical exercise involves inherent risks of injury. By participating in our classes and using our facilities, 
            you acknowledge these risks and agree that:
          </Paragraph>
          <List>
            <ListItem>You participate voluntarily and at your own risk</ListItem>
            <ListItem>The Sol Room and its instructors are not liable for any injuries sustained during classes</ListItem>
            <ListItem>You have adequate insurance coverage for any potential injuries</ListItem>
            <ListItem>You waive claims against The Sol Room for any damages or injuries</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>Membership and Payments</SectionTitle>
          <Paragraph>
            <strong>Payment Terms:</strong> All payments are due at the time of purchase. We accept credit cards, 
            debit cards, and electronic payments through our booking system.
          </Paragraph>
          <Paragraph>
            <strong>Package Expiration:</strong> Class packages expire 6 months from the date of purchase unless 
            otherwise specified. Extensions may be granted by studio management upon email request.
          </Paragraph>
          <Paragraph>
            <strong>Refund Policy:</strong> Refunds may be granted by studio management upon email request.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Studio Etiquette</SectionTitle>
          <List>
            <ListItem>Maintain a respectful and supportive environment for all participants</ListItem>
            <ListItem>Turn off or silence mobile devices during classes</ListItem>
            <ListItem>Wear appropriate athletic attire and bring a towel</ListItem>
            <ListItem>Clean equipment after use with provided supplies</ListItem>
            <ListItem>Respect studio property and equipment</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>Privacy and Photography</SectionTitle>
          <Paragraph>
            Occasionally, photos or videos may be taken during classes for promotional purposes. By attending classes, 
            you consent to being photographed and grant The Sol Room permission to use your likeness in marketing materials. 
            Please inform staff if you prefer not to be included.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Modifications to Terms</SectionTitle>
          <Paragraph>
            The Sol Room reserves the right to modify these Terms and Conditions at any time. Changes will be posted 
            on our website and take effect immediately. Continued use of our services after changes constitutes 
            acceptance of the new terms.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Contact Information</SectionTitle>
          <Paragraph>
            For questions about these Terms and Conditions, please contact us at help@thesolroom.com or 
            call 860-328-6854.
          </Paragraph>
        </Section>
      </Content>
      <Footer />
    </PageContainer>
  );
};

export default TermsPage;